import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const IconTechApachepulsar = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none" viewBox="0 0 48 48" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="#188FFF" d="M48 17.834H36.267C33.098 11.734 29.745 7 25.18 7c-5.94 0-8.734 5.2-11.433 10.258l-.236.442H0v3.006h7.869c2.778 0 3.344.939 3.344.939-2.18 3.393-4.8 6.746-9.167 6.746H0v3.156h2.062c8.467 0 12.165-6.888 15.131-12.42 2.723-5.097 4.62-8.182 7.987-8.182 3.494 0 7.169 7.622 10.403 14.353.472.978.952 1.98 1.44 2.975-12.401.394-18.31 3.306-23.119 5.68-3.517 1.737-6.295 3.89-10.867 3.89H0V41h3.014c5.508 0 8.939-1.704 12.59-3.511 5.06-2.494 10.796-5.318 24.315-5.318h7.814v-3.157h-4.415c-.167 0-.698 0-1.02-.316-1.927-2.288-2.45-3.55-3.19-5.128l-1.023-2.099s.732-.789 2.762-.789H48z" /></svg>;
const ForwardRef = forwardRef(IconTechApachepulsar);
export default ForwardRef;